/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AdminInputs */

const th_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ดูแลระบบ`)
};

const en_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

const ja_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const es_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administración`)
};

const pt_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administração`)
};

const id_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrasi`)
};

const fr_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

const tl_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangangasiwa`)
};

const vi_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản trị`)
};

const ko_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`관리`)
};

const de_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwaltung`)
};

const ru_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Администрирование`)
};

const tr_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönetim`)
};

const it_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amministrazione`)
};

const pl_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administracja`)
};

const uk_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адміністрування`)
};

const hi_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रशासन`)
};

const ar_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإدارة`)
};

const ms_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentadbiran`)
};

const bn_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রশাসন`)
};

const zh_tw2_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const zh_hk2_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理`)
};

const ur_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظامیہ`)
};

const fa_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت`)
};

const sw_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uendeshaji`)
};

const nl_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Nav_AdminInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_admin = /** @type {((inputs?: Nav_AdminInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AdminInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_admin(inputs)
	if (locale === "ja") return ja_nav_admin(inputs)
	if (locale === "zh") return zh_nav_admin(inputs)
	if (locale === "es") return es_nav_admin(inputs)
	if (locale === "pt") return pt_nav_admin(inputs)
	if (locale === "id") return id_nav_admin(inputs)
	if (locale === "fr") return fr_nav_admin(inputs)
	if (locale === "tl") return tl_nav_admin(inputs)
	if (locale === "vi") return vi_nav_admin(inputs)
	if (locale === "ko") return ko_nav_admin(inputs)
	if (locale === "de") return de_nav_admin(inputs)
	if (locale === "ru") return ru_nav_admin(inputs)
	if (locale === "tr") return tr_nav_admin(inputs)
	if (locale === "it") return it_nav_admin(inputs)
	if (locale === "pl") return pl_nav_admin(inputs)
	if (locale === "uk") return uk_nav_admin(inputs)
	if (locale === "hi") return hi_nav_admin(inputs)
	if (locale === "ar") return ar_nav_admin(inputs)
	if (locale === "ms") return ms_nav_admin(inputs)
	if (locale === "bn") return bn_nav_admin(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_admin(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_admin(inputs)
	if (locale === "ur") return ur_nav_admin(inputs)
	if (locale === "fa") return fa_nav_admin(inputs)
	if (locale === "sw") return sw_nav_admin(inputs)
	if (locale === "nl") return nl_nav_admin(inputs)
	return en_nav_admin(inputs)
});